import React from "react";
import Spinner from "./Spinner";

function EntityLoadingState({ icon }) {
    return (
        <div
            className="d-flex flex-column justify-content-center align-items-center"
            style={{ minHeight: "100vh" }}
        >
            <div
                className="rounded-circle d-flex align-items-center justify-content-center mb-3"
                style={{ width: 100, height: 100, background: "rgba(0,115,183,0.08)" }}
            >
                <i className={`fa ${icon} fa-3x text-primary`} />
            </div>
            <Spinner />
        </div>
    );
}

export default EntityLoadingState;
